// ##############################
// // // RegularCard styles
// #############################

import {
  card,
  cardHeader,
  defaultFont,
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  grayCardHeader,
  regularCard
} from "./globalStyles";

const regularCardStyle = {
  regularCard,
  cardPlain: {
    background: "transparent",
    boxShadow: "none"
  },
  cardHeader: {
    ...cardHeader,
    ...defaultFont,
    // marginBottom: '-20px'
  },
  cardPlainHeader: {
    marginLeft: 0,
    marginRight: 0
  },
  button: {
    color: 'white',
    backgroundColor: "#4e91fd",
},
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  grayCardHeader,
  cardTitle: {
    color: "black",
    marginTop: "0",
    marginBottom: "5px",
    ...defaultFont,
    fontSize: "1.125em"
  },
  cardSubtitle: {
    ...defaultFont,
    marginBottom: "0",
    color: 'black',
    margin: "0 0 10px"
  },

  tableCardContent : {
  paddingTop : '3px',  
  },

  cardContent : {
    paddingTop : '0px',  
    // minHeight:  '340px'
    },

  cardActions: {
    padding: "14px",
    display: "block",
    height: "auto",
    // float: 'right',
    paddingTop: '0px'
  }
};

export default regularCardStyle;



// WEBPACK FOOTER //
// ./src/assets/regularCardStyle.jsx